// Centralized LLM Gateway configuration for reuse across features

export const LLM_GATEWAY = 'https://test-llm.nuwa.dev';
export const LLM_GATEWAY_BASE_URL = `${LLM_GATEWAY}/openrouter/api/v1`;
